namespace nscs.scene {
    export class Boot extends Phaser.Scene {
        init() {
            new FitScaleManager(this.game).setup();
        }

        create() {
            this.input.addPointer(1);
            game.scene.remove('Boot');
            game.scene.add('Preloader', nscs.scene.Preloader, true);
        }
    }
}
